import { render, staticRenderFns } from "./WelcomeModal.vue?vue&type=template&id=43a61adf&scoped=true&"
import script from "./WelcomeModal.vue?vue&type=script&lang=js&"
export * from "./WelcomeModal.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeModal.vue?vue&type=style&index=0&id=43a61adf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a61adf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43a61adf')) {
      api.createRecord('43a61adf', component.options)
    } else {
      api.reload('43a61adf', component.options)
    }
    module.hot.accept("./WelcomeModal.vue?vue&type=template&id=43a61adf&scoped=true&", function () {
      api.rerender('43a61adf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/WelcomeModal.vue"
export default component.exports